import { UseraccessserviceService } from '../useraccessservice.service';
import { ApplicationRef, Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from './notification';
import { ComponentheaderService } from '../componentheader.service';
import { isNetworkFailure } from '../offline/offline-network-failure';
import { Router } from '@angular/router';
import { OfflineConnectivityService } from '../offline/offline-connectivity.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationInterceptor implements HttpInterceptor {

  private suspendNotification = false;
  get SuspendNotification(){
    return this.suspendNotification;
  }
  set SuspendNotification(value){
    this.suspendNotification = value;
  }

  // Injector, not a direct constructor param — OfflineConnectivityService's own constructor
  // already takes NotificationInterceptor (to suspend toasts during its heartbeat probe), so
  // resolving it back here directly would be a circular DI dependency. Injector.get() defers
  // the lookup to call-time, well after both are constructed, which breaks the cycle safely
  // (same pattern used in offline-connectivity.service.ts's own onReconnected()).
  constructor( private toastr : ToastrService, private notification :NotificationService, private headerinfo: ComponentheaderService, private router: Router, private ref: ApplicationRef, private injector: Injector)  {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error : any/*HttpErrorResponse*/) => {
        //debugger
        console.log(error);
        if(!this.SuspendNotification){
          if(isNetworkFailure(error) && this.isAlreadyKnownOffline()){
            // The banner (or the admin overlay) is already telling the user they're
            // offline — a fresh "Unable to connect to server" toast on every single failed
            // request while in that state is pure noise, not new information.
          }
          else if(isNetworkFailure(error)){
            this.showError("Unable to connect to server", "Connection Error", 5000);
          }
          else if(error.status === 400){
            this.showError(error, "Error", 8000);
          }
          else if(error.status === 401){
            // Expired or missing session: back to sign-in, keeping offline downloads.
            // Only the Log out button (/logout) wipes them.
            this.showError('Your session has expired. Please sign in again.', "Signed out", 5000);
            this.injector.get(UseraccessserviceService).endExpiredSession();
          }
          else if (error.status === 404){
            this.showError(error, "Error", 8000);
          }
          else{
            this.showError(error);
          }
          this.headerinfo.pageLoadingError();
        }

        //in some cases, (e.g. when there is an error registering via the login with google popup), the toastr doesn't display because the user is not on the page (i.e. the user is actually on the popup)
        //in that cases, the tick forces an update which appears to cause the toastr to be rendered in html properly properly (except for the opacity and display for some reason)
        //the opacity = 1 and display = 'block' had to be added for it to display

        this.ref.tick();

        setTimeout(() => {
          const toastrdiv: any = document.querySelector('#toast-container > div');
          toastrdiv.style.opacity = 1;
          toastrdiv.style.display = 'block';
        });

        return throwError(error);
      })
    );

  }

  // Lazily resolved via Injector.get() (not a constructor param) to avoid the circular-DI
  // issue described above — the ES import itself is fine (TS/webpack handle circular module
  // imports via live bindings), it's Angular's constructor-time DI resolution that can't
  // handle two singletons each directly requiring the other. Also defensive against
  // OfflineConnectivityService erroring for any reason — a notification bug must never
  // block the app from reporting a real connection error.
  private isAlreadyKnownOffline(): boolean {
    try {
      return this.injector.get(OfflineConnectivityService).currentState !== 'online';
    } catch {
      return false;
    }
  }

  showError(error, title = 'Error', timeout = 5000){
    if(typeof error === 'string'){
      this.toastr.error(error, title, { timeOut : timeout });      
    }
    else{
      if(error.error && error.error.message){
        this.showError(error.error.message, title, timeout);
      }
      else if(error.error && error.error.errors  && Object.keys(error.error.errors).length > 0){
        for(let item in error.error.errors){
          const errormessages: string[] = error.error.errors[item];
          errormessages.forEach(errormessage => {
            //this.toastr.error(errormessage, `Error: ${item}`);
            this.showError(errormessage, item, timeout);
          });
        }
      }
      else if(error.message){
        this.showError(error.message, title, timeout);
      }
      
      else{
        this.showError('Unexpected Error', title, timeout);
      }
    }
  }
}
